module.exports = __webpack_public_path__ + "static/gm-7-12fb5ef790b1993f52f2706a5ccbddb9.jpg";